/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { FunctionComponent, useEffect } from 'react';

import { DeviceModel, Settings } from '../../../core/device';
import { BrandingUiInfoKeys } from '../../../core/entities';
import { ServicesClientImpl } from '../../../core/interactors';
import { Locale, LocaleKeys } from '../../../core/locale';
import { KeyManager } from '../../../core/navigation';
import { SettingsTemplate } from '../SettingsTemplate';

import '../SettingsCommon.scss';
import './InfoScreen.scss';

const InfoScreen: FunctionComponent = (): JSX.Element => {
    const service = new ServicesClientImpl();
    const settingsService = new Settings();
    const isVideoWindowEnabled = settingsService.isVideoWindowEnabled();
    const details = [
        {
            title: Locale.getString(LocaleKeys.SETTINGS_APP_VERSION),
            value: DeviceModel.getAppVersionName(),
        },
        {
            title: Locale.getString(LocaleKeys.SETTINGS_SHELL_APP_VERSION),
            value: DeviceModel.getTiVoSettings().getShellVersion(),
        },
        {
            title: Locale.getString(LocaleKeys.SETTINGS_SUPPORT),
            value: service.getBrandingUiInfoForKey(BrandingUiInfoKeys.URL_CUSTOMER_SUPPORT),
        },
        {
            title: Locale.getString(LocaleKeys.SETTINGS_PRIVACY_POLICY),
            value: service.getBrandingUiInfoForKey(BrandingUiInfoKeys.URL_PRIVACY),
        },
        {
            title: Locale.getString(LocaleKeys.SETTINGS_CA_DEVICE_ID),
            value: DeviceModel.getCaDeviceId(),
        },
        {
            title: Locale.getString(LocaleKeys.SETTINGS_TIVO_SERVICE_NUMBER),
            value: DeviceModel.getTiVoSettings().getDeviceTsn(),
        },
    ];

    useEffect(() => {
        const keyManagerIns: KeyManager = KeyManager.getInstance();
        if (keyManagerIns.isKeyIgnoring()) {
            keyManagerIns.stopKeyIgnoring();
        }
    }, []);

    return (
        <SettingsTemplate title={Locale.getString(LocaleKeys.SETTINGS_INFO_TITLE)}>
            <div
                className={`settings-common-content info-container ${!isVideoWindowEnabled ? 'full-screen' : null}`}
            >
                {details
                    .filter((item) => item.value)
                    .map((item, index) => {
                        return (
                            <div key={index} className="info-item">
                                <span className="title">{item.title}:</span>
                                <span
                                    className={`value ${!isVideoWindowEnabled ? 'video-window-off' : null}`}
                                >
                                    {item.value}
                                </span>
                            </div>
                        );
                    })}
            </div>
        </SettingsTemplate>
    );
};

export default InfoScreen;
